/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDropbox = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 3 2 6.375l5 3.374 5-3.374zm10 0-5 3.375 5 3.374 5-3.374zM2 13.125 7 16.5l5-3.375-5-3.376zm15-3.376-5 3.376 5 3.375 5-3.375zM7 17.625 12 21l5-3.375-5-3.374z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDropbox as Dropbox };
